import { Controller } from 'stimulus';

export default class extends Controller {
    // get targets
    static targets = ['toggleSection']

    toggleMenu() {
        this.toggleSectionTarget.classList.toggle("hidden");
    }
}